export const FILTERS = {
  FAIL_FETCH: "FILTERS_FAIL_FETCH",
  SUCCESS_FETCH: "FILTERS_SUCCESS_FETCH",
};
